import {
  defer,
  json,
  MetaArgs,
  MetaFunction,
  useLoaderData,
} from "@remix-run/react";
import { getSeoMeta } from "@shopify/hydrogen";
import type { LoaderFunctionArgs } from "@shopify/remix-oxygen";
import Route from "~/components/routes/Route";
import TemplateSingleMember from "~/components/templates/TemplateSingleMember";
import { queryMember, queryPage } from "~/queries/page";
import { Member as IMember } from "~/sanity/types";
import { Page as IPage } from "~/sanity/types";

export const meta = ({ matches }: MetaArgs<typeof loader>) => {
  return getSeoMeta(...matches.map((match) => (match.data as any).seo));
};

export async function loader({ request, params, context }: LoaderFunctionArgs) {
  const { sanity } = context;
  const { handle } = params;

  let template;
  let status;
  let page = await sanity.loadQuery<IMember>(queryMember, {
    slug: params.handle,
  });

  if (!page.data.image || !handle) {
    if (
      page.data?._originalId?.match(/^drafts\..*/) &&
      context.sanity.preview?.enabled
    ) {
      throw new Response("Under Construction", {
        status: 503,
      });
    } else {
      page = await sanity.loadQuery<IMember>(queryPage, { slug: "404" });
      status = 404;
      throw new Response(JSON.stringify(page.data), {
        status: 404,
      });
    }
  }

  // const status = (template === "templatePage404" && 404) || undefined;

  const title = `${page.data?.firstname} ${page.data?.lastname}`;
  const seo = {
    title,
  };

  return defer(
    {
      routeType: "member",
      page,
      seo,
    },
    {
      status,
    },
  );
}

export default function Component() {
  const data = useLoaderData<typeof loader>();
  const template = data?.page?.data;
  // console.log(data);
  return <TemplateSingleMember data={template} />;
}
